
import { Component, Inject, Vue } from 'vue-property-decorator';
import PageName from '../../core/components/PageName.vue';
import { ItemInfo } from '../../shared/types/itemInfo';
import LoadingIndicator from '../../core/components/Generics/LoadingIndicator.vue';
import ItemIndicators from './components/ItemIndicators.vue';
import ItemMap from './components/ItemMap.vue';
import Button from '../../core/components/Generics/Button.vue';
import { FeatureCollection, MultiPolygon } from '../../shared/types/MapShapes';
import { splitMultiPolygonToFeatures } from '../../core/utils/map-utils';
import { defaultUserPrivilege, PrivilegeValue, PRIVILEGE_KEYS } from '../../shared/privileges/privileges';
import { isValidRedirectUrl } from '../../shared/helpers/is-valid-redirect-url';
import { ItemPort } from '../../core/api/ports';
import { InjectionKey } from '../../core/injection-keys';
import { IndicatorConfig, ItemExitMode, ItemPageConfig, TenantConfig } from '../../tenants/types';
import { CustomerContext } from '../../core/auth/CustomerContext';
import { hasItemPageOverrides, resolveItemIndicators } from '../../core/customer';
@Component({
    components: {
        PageName,
        LoadingIndicator,
        ItemIndicators,
        ItemMap,
        Button
    }
})
export default class PageItemDetail extends Vue {
    @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
    @Inject(InjectionKey.ItemApi) readonly itemApi!: ItemPort;
    @Inject(InjectionKey.Customer) readonly customerContext!: CustomerContext;
    pendingInfo: boolean = true;
    itemInfo: ItemInfo | null = null;
    errorDetail: boolean = false;
    polygonsArea: string = '-';
    diffPolygonsArea: number = 0;
    snackbarMessage: string = '';
    showSnackbar: boolean = false;
    snackbarColor: string = 'info';
    redirectUrl: string = '';
    /** `null` = la página no muestra centroide (`showCentroid`); con centroide inválido queda en 0,0 y `centroidIsValid` false. */
    centroidInfo: { lat: number, lng: number } | null = null;
    centroidIsValid: boolean = false;
    userPrivilege: PrivilegeValue = defaultUserPrivilege;

    get pageConfig(): ItemPageConfig {
        return this.tenant.pages.item as ItemPageConfig;
    }

    /**
     * Si algún perfil de aseguradora cambia esta página, se espera a conocer la aseguradora de la ruta (o a que su
     * `/me/` falle → valores del tenant) para no mostrar y luego sacar indicadores. Sin perfiles, se muestra ya.
     */
    get customerReady(): boolean {
        return !hasItemPageOverrides(this.tenant.customers) || this.customerContext.resolved;
    }

    /** `pages.item.indicators` sin los que oculta el perfil de la aseguradora activa. */
    get indicators(): IndicatorConfig[] {
        return resolveItemIndicators(this.pageConfig.indicators, this.tenant.customers, this.customerContext.customerId);
    }

    get isReadOnly(): boolean {
        return this.userPrivilege === PRIVILEGE_KEYS.READ_ONLY;
    }
    
    updateAreaIndicator(response){
        let polygonArea = response.calculated_area.toFixed(2);
        let diffArea = response.area_diff_percent.toFixed(2);

        let area = `${polygonArea}`;
        if(response && response.area_diff_percent){
            area += ` - Dif. (${diffArea}%)`;
        }
        this.diffPolygonsArea = diffArea;
        this.polygonsArea = area;
    }


    showAlert(message: string, color: string) {
        this.snackbarMessage = message;
        this.showSnackbar = true;
        this.snackbarColor = color

    }

    leaveItem(newUrl: string | null) {
        if (this.pageConfig.exitMode === ItemExitMode.CloseWindowThenRedirect) {
            this.closeWindowThenRedirect();
            return;
        }

        const targetUrl = newUrl && newUrl !== '' ? newUrl : this.redirectUrl;

        if (!isValidRedirectUrl(targetUrl)) return;

        setTimeout(() => {
            window.location.href = targetUrl;
        }, 1000);
    }

    // Comportamiento previo a "al enviar el item actualizar url redirect" (ignora la URL que devuelve el PATCH)
    closeWindowThenRedirect() {
        let haveUrl = isValidRedirectUrl(this.redirectUrl);
        let self = this;
        if(haveUrl) {
            setTimeout(() => {
                window.location.href = self.redirectUrl;
            }, 1300);

            setTimeout(() => {
                window.open('', '_self');
                window.close();
            }, 500);
        }
    }

    // El token (si el tenant usa acceso por URL) ya lo fijó `UrlTokenStrategy` en el guard del router.
    created(){
        this.getItemInfo()
    }

    // `:id` de la URL tal cual (puede no ser numérico): el adaptador decide si lo manda al backend.
    getItemId(): string {
        return this.$route.params.id
    }



    getItemInfo(){
        this.errorDetail = false;
        this.pendingInfo = false;
        localStorage.removeItem('department_polygon');
        this.itemApi.getItemDetail(
            this.getItemId(),
        ).then((response: ItemInfo) => {
            let itemPolygon:FeatureCollection | null = response && response['polygon'] as FeatureCollection | null;
            this.userPrivilege = response.privilege;
            this.redirectUrl = response.redirect_url;
            if(this.pageConfig.showCentroid){
                const centroid = response.centroidPoint || null;
                this.centroidInfo = centroid || { lat: 0, lng: 0 };
                this.centroidIsValid = centroid !== null;
            }
            
            if(itemPolygon !== null){
                //el backend envia una unica feature con todos los poligonos,
                //por lo que hay que dividirlo en multiples features para que al eliminar una feature no se eliminen todos los poligonos
                response.polygon = splitMultiPolygonToFeatures(itemPolygon);
            }
            this.itemInfo = response;
            this.saveDepartmentLimitsPolygon();
        }).catch((error) => {
        this.errorDetail = true
        this.itemInfo = null 
        }).finally(() => {
            this.pendingInfo = false
            
        })
    }

    async saveDepartmentLimitsPolygon(){
       let departmentPolygon: null | MultiPolygon = null;

       // `department_polygon` puede venir `null`: entonces no se guarda nada (ya se borró el de otro item).
       if(this.itemInfo && this.itemInfo.department_polygon){
        departmentPolygon = this.itemInfo.department_polygon;
           await localStorage.setItem('department_polygon', JSON.stringify(departmentPolygon));
       }

    }

    async setCityLimitsQuery(){
        let query = '';
        let department = '';
        let province = '';
        await localStorage.removeItem('item_limits_query');

        if(this.itemInfo){
            department = this.itemInfo.department;
            province = this.itemInfo.province;
        }

        if(department === '' || province === '') return

        
        query = `${department} Department, ${province} Province, Argentina`;
        await localStorage.setItem('item_limits_query', query);
    }


   

}
